<template>
  <div>
    <div class="row">
      <div class="col-12 col-sm-6">
        <multiselect v-if="all_available_people.length" v-model="podcast.people"
                     :options="all_available_people"
                     :multiple="true"
                     track-by="uuid"
                     label="name"
                     placeholder="Select Existing Person">
          <template #noResult>
            Search has no Results.
          </template>
          <template #selection="{ values, isOpen }">
            <span v-if="values.length === 1 && !isOpen">
              1 Person Selected
            </span>
            <span v-else-if="values.length > 1 && !isOpen">
              {{ values.length }} People Selected
            </span>
          </template>
          <template #option="props">
            <span>
              <span>
                <img v-if="props.option.artwork?.thumbnail_path"
                     :src="props.option.artwork.thumbnail_path"
                     height="50px"
                     class="mr-2">
              </span>
              {{ props.option.name }} ({{ props.option.group }} : {{ props.option.role }})
            </span>
          </template>
        </multiselect>
      </div>
      <div class="col-12 col-sm-6 text-right">
        <button class="btn btn-ss-standout btn-icon-sm" @click="toggleCreateModal">
          <i class="la la-plus" /> New Person
        </button>
      </div>
    </div>
    <div v-if="podcast.people.length" class="row mt-4">
      <div v-for="person in podcast.people" :key="person.uuid" class="col-6 col-sm-6 col-md-3 mb-4 text-center">
        <person-card :person="person" :is-podcast="true" />
      </div>
    </div>
    <div v-if="!all_available_people.length">
      <h5 class="empty-content-margin text-center">
        You have not created any people yet. Click the '+ Person' button above to create your first person.
      </h5>
    </div>
    <div v-if="all_available_people.length && !podcast.people.length">
      <h5 class="empty-content-margin text-center">
        You have no people selected. Please choose an existing person from the dropdown or click the '+ Person' button above to add a new person.
      </h5>
    </div>
    <person-create-modal name="person_create_modal" />
    <person-edit-modal name="person_edit_modal" />
  </div>
</template>

<script>

import { mapActions, mapWritableState } from 'pinia';
import { usePodcastManageStore } from "VueStore/app/podcastManage";
import { usePeopleStore } from "VueStore/app/people";
import PersonCard from "VuePartials/People/PersonCard";
import PersonCreateModal from "VueModals/PersonCreateModal";
import PersonEditModal from "VueModals/PersonEditModal";

export default {
  components: { PersonCard, PersonCreateModal, PersonEditModal },
  computed: {
    ...mapWritableState(usePodcastManageStore, ['podcast']),
    ...mapWritableState(usePeopleStore, ['all_available_people']),
    ...mapWritableState(usePeopleStore, ['taxonomy']),
    ...mapWritableState(usePeopleStore, ['selected_taxonomy']),
  },
  mounted() {
    this.getTaxonomy();
    this.getAllPeople();

    EventBus.$on('person-default-toggled', (payload) => {
      const person_index = _.findIndex(this.podcast.people, [
        'uuid',
        payload.person.uuid,
      ]);
      this.podcast.people[person_index].is_default = payload.new_value;
    });

    EventBus.$on('new-person-created', (payload) => {
      this.getAllPeople();
      this.podcast.people.push(payload);
    });

    EventBus.$on('person-updated', (payload) => {
      const person_index = _.findIndex(this.podcast.people, [
        'uuid',
        payload.uuid,
      ]);
      this.podcast.people[person_index] = payload;
      this.getAllPeople();
    });

    EventBus.$on('remove-selected-person', (payload) => {
      this.podcast.people = _.filter(this.podcast.people, person => person.uuid !== payload.uuid);
    });
  },
  methods: {
    ...mapActions(usePeopleStore, ['getAllPeople']),
    ...mapActions(usePeopleStore, ['getTaxonomy']),
    ...mapActions(usePeopleStore, ['setupPersonCreate']),
    async toggleCreateModal() {
      this.setupPersonCreate();
      this.fireModal('person_create_modal');
    },
  },
};
</script>
